import { StoreModelCollection } from "@bitwarden/web-vault/app/services/store/model.collection.abstraction";
import { StoreModelNames } from "../../dali/type/dali.type";
import { InstitutionStoreModel } from "../../../models/store/institution.store.model";
import { signal } from "@angular/core";
import { InstitutionView } from "@bitwarden/web-vault/app/models/view/institution/institution.view";

export class InstitutionsStoreCollection extends StoreModelCollection {
  readonly type: StoreModelNames = "InstitutionStoreModel";
  protected models: Map<string, InstitutionStoreModel> = new Map<string, InstitutionStoreModel>();

  private _institutionViews = signal<InstitutionView[]>(null);
  readonly institutionViews = this._institutionViews.asReadonly();

  triggerChanges(): void {
    const views: InstitutionView[] = [];
    this.models.forEach((model) => {
      views.push(this.deepFreeze(new InstitutionView(model)));
    });
    this._institutionViews.set(views);
  }

  clear(): void {
    this.models.clear();
    this._institutionViews.set(null);
  }
}
